var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrb360Txt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ORB360 + Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Menu",
    transform: "translate(-648.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ORB360-+-Text",
    transform: "translate(648.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CDD4DA",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 107
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(82.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EBEDF0",
    x: 0,
    y: 0,
    width: 72,
    height: 96
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Text/M/Default",
    transform: "translate(24.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,8 C3,8.55228475 3.44771525,9 4,9 C4.55228475,9 5,8.55228475 5,8 L5,6 L11,6 L11,19 L9,19 C8.44771525,19 8,19.4477153 8,20 C8,20.5522847 8.44771525,21 9,21 L15,21 C15.5522847,21 16,20.5522847 16,20 C16,19.4477153 15.5522847,19 15,19 L13,19 L13,6 L19,6 L19,8 C19,8.55228475 19.4477153,9 20,9 C20.5522847,9 21,8.55228475 21,8 L21,5 C21,4.44771525 20.5522847,4 20,4 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8C9BA8",
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 95
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8C9BA8",
    x: 0,
    y: 0,
    width: 72,
    height: 96
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/360/M/White-Default",
    transform: "translate(24.000000, 36.000000)",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "360Image",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7848101,8.09924051 C23.3815869,8.63585059 23.7328453,9.39325149 23.756962,10.195443 C23.756962,12.1701266 21.2658228,13.9017722 17.5898734,14.8131646",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.12658228,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9696203,15.4511392 C5.43797468,15.4511392 0.151898734,13.1118987 0.151898734,10.2258228 C0.181888592,9.42503115 0.532136411,8.66980929 1.12405063,8.12962025",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2.12658228,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90126582,16.5448101 L8.90126582,18.1549367 C8.90126582,19.0663291 9.53924051,19.3093671 10.2379747,18.7929114 L13.9746835,16.1498734 C14.5518987,15.7549367 14.5822785,15.116962 13.9746835,14.7220253 L10.2379747,12.0789873 C9.53924051,11.5625316 8.90126582,11.8055696 8.90126582,12.7473418 L8.90126582,14.2663291",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.734177, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820253165,5.16455696 C1.11029796,5.18606753 1.37137512,5.34838941 1.51898734,5.59898734 C1.80699923,6.01862125 2.28603482,6.26612297 2.79493671,6.25822785 C3.49974684,6.25822785 3.95848101,5.89063291 3.95848101,5.31949367 C3.95848101,4.74835443 3.49367089,4.36860759 2.80101266,4.36860759 L2.36658228,4.36860759 C2.19090168,4.36968554 2.02255188,4.2982695 1.90123273,4.17120062 C1.77991358,4.04413175 1.71636382,3.87265774 1.72556962,3.69721519 C1.71890954,3.52358928 1.78369438,3.35481954 1.90482245,3.23024707 C2.02595053,3.10567459 2.19283791,3.03618428 2.36658228,3.03797468 L2.78278481,3.03797468 C3.36,3.03797468 3.78531646,2.67341772 3.78531646,2.17822785 C3.78531646,1.68303797 3.36911392,1.33670886 2.77063291,1.33670886 C2.30538349,1.34159791 1.87380813,1.58022027 1.62227848,1.97164557 C1.46723895,2.20174597 1.20706813,2.33867799 0.929620253,2.33620253 C0.744834896,2.34721313 0.56381653,2.28074009 0.430071095,2.15275955 C0.29632566,2.024779 0.221946583,1.84686311 0.224810127,1.66177215 C0.224810127,0.780759494 1.36101266,0.00604204391 2.80405063,0.00604204391 C4.36253165,-8.67361738e-19 5.46835443,0.811139241 5.46835443,1.95949367 C5.47501186,2.73728924 4.91656979,3.4051036 4.14987342,3.53620253 L4.14987342,3.64556962 C5.0395425,3.72708424 5.71187956,4.48729109 5.68405063,5.38025316 C5.66886076,6.6835443 4.47797468,7.59493671 2.79493671,7.59493671 C1.31240506,7.59493671 0.145822785,6.78987342 0.145822785,5.87848101 C0.130209561,5.69170091 0.194840172,5.50710484 0.323552097,5.37085573 C0.452264022,5.23460662 0.63288754,5.15958683 0.820253165,5.16455696 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41772152,-9.78752669e-14 C10.0350334,-0.0173556561 10.6440688,0.145194527 11.1706329,0.467848101 C11.5110067,0.656270825 11.7428486,0.993904632 11.7964557,1.37924051 C11.8024022,1.55346576 11.7332279,1.72185236 11.6065223,1.84158331 C11.4798167,1.96131426 11.3077873,2.02085414 11.1341772,2.00506329 C10.8772427,1.99634402 10.631321,1.89861965 10.438481,1.72860759 C10.1590026,1.48390892 9.80131269,1.34708174 9.42987342,1.34278481 C8.47898734,1.34278481 7.98379747,2.16 7.97772152,3.66075949 L8.02632911,3.66075949 C8.34470301,2.99828052 9.02661801,2.58865382 9.76101266,2.61873418 C11.0946835,2.61873418 12.0243038,3.58481013 12.0273418,4.96708861 C12.0273418,6.52253165 10.921519,7.55848101 9.29316456,7.55848101 C8.4285576,7.60145942 7.59813944,7.21635442 7.07240506,6.52860759 C6.59240506,5.89367089 6.34025316,4.96101266 6.34025316,3.81873418 C6.34329114,1.39139241 7.45822785,-9.78752669e-14 9.41772152,-9.78752669e-14 Z M9.29316456,6.22481013 C9.5955327,6.22519391 9.8840939,6.09827168 10.0881498,5.87513978 C10.2922056,5.65200787 10.3929026,5.35328235 10.3655696,5.0521519 C10.3904448,4.74906247 10.2862017,4.44955739 10.0785175,4.22741049 C9.87083331,4.00526359 9.5790127,3.88112398 9.27493671,3.88556962 C8.97493555,3.89067643 8.69020762,4.01881163 8.48743407,4.23996692 C8.28466052,4.46112221 8.18165175,4.75587264 8.20253165,5.05518987 C8.18236661,5.36035996 8.28948719,5.66025424 8.49843085,5.88358797 C8.70737452,6.1069217 8.99948091,6.23374935 9.30531646,6.23392405 L9.29316456,6.22481013 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6622785,3.59088608 C12.6622785,1.4156962 13.7772152,0 15.5726582,0 C17.3681013,0 18.4435443,1.38835443 18.4465823,3.5878481 L18.4465823,3.97670886 C18.4465823,6.14582278 17.3164557,7.59493671 15.5362025,7.59493671 C13.7559494,7.59493671 12.6653165,6.19139241 12.6622785,3.99189873 L12.6622785,3.59088608 Z M14.4364391,3.97367089 C14.4364391,5.36202532 14.8526582,6.17316456 15.5574684,6.17316456 C16.2622785,6.17316456 16.678481,5.35594937 16.678481,3.97367089 L16.678481,3.59392405 C16.678481,2.21468354 16.2562025,1.40962025 15.5513924,1.40962025 C14.8465823,1.40962025 14.4334177,2.21164557 14.4364391,3.59392405 L14.4364391,3.97367089 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrb360Txt);
export default __webpack_public_path__ + "static/media/icon_orb360_txt.6c6f811a.svg";
export { ForwardRef as ReactComponent };